<template>
  <div class="container-fluid p-0">
    <Card>
      <template v-slot:header>
        <div class="text-center p-3">
          <h4>
            {{ Today }}
          </h4>
        </div>
      </template>
      <template slot="content">
        <div class="MainNote Rounded border">
          <div v-if="notes.length < 1">
            <h4 class="m-5">یادداشتی پیدا نشد</h4>
          </div>
          <div v-else>
            <textarea @blur="SaveChanges" v-model="DataAxios.Text" ></textarea>
          </div>

          <div class="listN hover" id="listN">
            <a @click="addnew()" class="m-5">
              <i class="addbtn text-success fas fa-plus h5"></i>
            </a>
            <div class="ml-5 mt-3" style="overflow-y: scroll; height: 100% !important">
              <div v-for="(note, index) in notes" :key="index" class="row pb-1 mx-4">
                <div @click="Selectnote(note)" class="col-12 float-top border ml-1 Rounded p-2 Pointer notelist">
                  {{ note.Text.length > 25 ? note.Text.slice(0, 25) + " ... " : note.Text }}
                  <a @click="Delete(note.Id)" class="hover-danger">
                    <span class="float-left hover-danger"><i class="fad fa-times hover-danger"></i> </span
                  ></a>
                </div>
              </div>
            </div>
            <!-- <i class="fas fa-chevron-circle-left btn-left"></i> -->
          </div>

        </div>    
        <div class="mr-2 mt-2 row" v-if="DataAxios.HasSharp">
          <div v-for="(cus, index) in DataAxios.CustomerCode">
            <a @click="goToCustomer(cus)" class="text-success">{{cus}}@</a>
            <span v-if="index != DataAxios.CustomerCode.length - 1" class="text-danger">__</span>
            <span v-if="DataAxios.TicketId.length > 0 & index == DataAxios.CustomerCode.length - 1" class="text-danger">__</span>
          </div>
          <div v-for="(tic, index) in DataAxios.TicketId">
            <a @click="goToTicket(tic)" class="text-success">#{{tic}}</a>
            <span v-if="index != DataAxios.TicketId.length - 1" class="text-danger">__</span>
          </div>
        </div>  
      </template>
    </Card>
  </div>
</template>
<script>
import Card from "@/components/Card/Card.vue";
import moment from "moment-jalaali";
export default {
  data() {
    return {
      notes: [],
      DataAxios: {},
      Emptynote: {
        Id: 123,
        tbluserId: this.$session.get("UserInfo").tblUserId,
        tblUserGrpInsert: this.$session.get("UserInfo").tblUserGrpId,
        Text: "",
        DateTimeInsert: "",
        DateTimeLastEdit: "",
        Today: "",
      },
    };
  },
  methods: {
    Selectnote(data) {
      this.DataAxios = data;
      document.getElementById("listN").classList.remove("hover");
      setTimeout(function () {
        document.getElementById("listN").classList.add("hover");
      }, 500);
    },
    Getnotes() {
      var DataAxiosGet = { Method: "POST", Action: "TblNotes/GetNotes", ArryfildValue: { Id: this.$session.get("UserInfo").tblUserId }, Token: this.$session.get("Token") };
      this.$PostData(DataAxiosGet)
        .then((result) => {
          this.notes = result.usernotes;
          if (this.notes.length > 0) {
            this.Selectnote(this.notes[0]);
          }
          this.checkSharp();
        })
        .catch((error) => {
          this.$toasted.danger("مشکلی در بارگذاری یادداشت ها بوجود آمده است.", {
            action: {
              text: "بستن",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          });
        });
    },
    addnew() {
      this.notes.push(JSON.parse(JSON.stringify(this.Emptynote)));
      this.Selectnote(this.notes[this.notes.length - 1]);
    },
    SaveChanges() {
      var DataAxiosGet = { Method: "POST", Action: "TblNotes/Edit", ArryfildValue: this.notes, Token: this.$session.get("Token") };
      this.$PostData(DataAxiosGet).then((data) => {
        this.notes = data.notes;
        this.checkSharp();
      });
    },
    Delete(id) {
      var DataAxiosDelete = { Method: "DELETE", Action: "TblNotes", ArryfildValue: { Id: id } };
      this.$PostData(DataAxiosDelete).then((result) => {
        if (result.status == "success") {
          this.$mySweetDefaultTost("حذف", "یادداشت با موفقیت حذف شد", "success", 1000);
          this.Getnotes();
        }
      });
    },
    checkSharp() {
      this.notes.forEach((el) => {
        let customerCode = "";
        let ticketId = "";
        el.CustomerCode = []
        el.TicketId = []
        for (let i = 0; i < el.Text.length; i++) {
          if (el.Text[i] == "@") {
            for (let index = i + 1; index < el.Text.length; index++) {
              if (el.Text[index] == " " || el.Text[index] == '\n') {
                el.CustomerCode.push(customerCode)
                customerCode = "";
                break;
              }
              if(index == el.Text.length - 1){
                customerCode += el.Text[index] + "";
                el.CustomerCode.push(customerCode)
                customerCode = "";
                break;
              }
              customerCode += el.Text[index] + "";
            }
          }

          if (el.Text[i] == "#") {
            for (let index = i + 1; index < el.Text.length; index++) {
              if (el.Text[index] == " " || el.Text[index] == '\n') {
                el.TicketId.push(ticketId);
                ticketId = ""
                break;
              }
              if (index == el.Text.length - 1) {
                ticketId += el.Text[index] + "";
                el.TicketId.push(ticketId);
                ticketId = ""
                break;
              }
              ticketId += el.Text[index] + "";
            }
          }
        }
        if (el.CustomerCode != undefined || el.TicketId != undefined) {
          el.HasSharp = true;
        } else {
          el.HasSharp = false;
        }
      });
    },
    goTo(item) {
      if (item.HasSharp) {
        if (item.CustomerCode != undefined) {
          var DataAxiosGet = { Method: "POST", Action: "TblNotes/GetCustomerId", ArryfildValue: { Id: item.CustomerCode } };
          this.$PostData(DataAxiosGet)
            .then((result) => {
              this.$router.push({ name: "DetailCustomer", params: { tblCustomerId: result.customerId } });
            })
            .catch((error) => {
              console.error(error)
            });
        }
        if (item.TicketId != undefined) {
          var DataAxiosGet = { Method: "POST", Action: "TblNotes/GetTicket", ArryfildValue: { Id: item.TicketId } };
          this.$PostData(DataAxiosGet)
            .then((res) => {
              this.$router.push({
                name: "ChatRoom",
                params: {
                  chatRoomId: res.tblChatRoomId,
                  ticketManagerTblUserId: res.tblUserId,
                  ticketId: res.id,
                  tblComboIdTicketStatus: res.tblComboGrpId41,
                  departmentId: res.tblDepartmentId,
                  customerName: res.customerName,
                  customerCode: res.customerCode,
                  tblCustomerId: res.tblCustomerId,
                  tblUserGrpIdInsertTicket: res.tblUserGrpIdInsert,
                },
              });
            })
            .catch((error) => {
              console.error(error)
            });
        }
      }
    },
    goToCustomer(cusCode){
      var DataAxiosGet = { Method: "POST", Action: "TblNotes/GetCustomerId", ArryfildValue: { Id: cusCode } };
          this.$PostData(DataAxiosGet)
            .then((result) => {
              this.$router.push({ name: "DetailCustomer", params: { tblCustomerId: result.customerId } });
            })
            .catch((error) => {
              console.error(error)
            });
    },
    goToTicket(tickId){
      var DataAxiosGet = { Method: "POST", Action: "TblNotes/GetTicket", ArryfildValue: { Id: tickId } };
          this.$PostData(DataAxiosGet)
            .then((res) => {
              this.$router.push({
                name: "ChatRoom",
                params: {
                  chatRoomId: res.tblChatRoomId,
                  ticketManagerTblUserId: res.tblUserId,
                  ticketId: res.id,
                  tblComboIdTicketStatus: res.tblComboGrpId41,
                  departmentId: res.tblDepartmentId,
                  customerName: res.customerName,
                  customerCode: res.customerCode,
                  tblCustomerId: res.tblCustomerId,
                  tblUserGrpIdInsertTicket: res.tblUserGrpIdInsert,
                },
              });
            })
            .catch((error) => {
              console.error(error)
            });
    }

  },
  created() {
    this.Today = moment().format("dddd jDD jMMMM jYYYY");
    this.Getnotes();
  },
  components: { Card },
};
</script>
<style scoped>
.addbtn {
  position: absolute;
  top: 3%;
  right: 3%;
}
.container {
  overflow: hidden;
}

.btnSabt {
  position: absolute;
  left: 2%;
  bottom: 2%;
  font-size: large;
}
.MainNote {
  height: 250px;
}
.listN {
  transition: 0.5s;
  position: absolute;
  top: 0;
  right: -75%;
  height: 100%;
  width: 75%;
  display: inline-block;
  background: var(--sidebar-action-bg);
  /* border-left:  solid 1px var(--sidebar-color-item) */
}
.hover:hover {
  width: 75% !important;
  right: 0 !important;
  transition: 0.5s !important;
}

.a {
  transition: 0.5s;
  position: absolute;
  top: 0;
  right: -75%;
  height: 100%;
  width: 75%;
  display: inline-block;
  background: var(--sidebar-action-bg);
}
.btn-left {
  position: absolute;
  left: -15px;
  top: 48%;
  color: var(--sidebar-action-bg);
  z-index: 100;
  font-size: 25px;
}
/* .note{
height: 100%;
width: 90%;
display: inline-block;

} */
.MainNote {
  position: relative;
  overflow: hidden;
}

.listN::before {
  position: absolute;
  left: -13px;
  top: 30%;
  content: "";
  display: inline-block;
  width: 30px;
  height: 70px;
  -moz-border-radius: 100%;
  -webkit-border-radius: 100%;
  border-radius: 100%;
  background-color: var(--sidebar-action-bg);
  content-visibility: visible;
  border-left: solid 1px #bedfff;
}
.MainNote textarea {
  width: 95%;
  padding: 2%;
  height: 90%;
  resize: none;
  left: 0;
  position: absolute;
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
  background: var(--sidebar-bg-color) !important;
  caret-color: var(--sidebar-color-item);
  color: var(--sidebar-color-item);
}
textarea:focus {
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
}
.datediv {
  position: absolute;
  width: 100%;
  height: 8%;
  bottom: 0;
  font-size: x-small;
  padding-right: 5%;
}
.notelist {
  background: var(--sidebar-bg-color);
  height: fit-content;
}
.notelist:hover {
  background: #bedfff;
  color: darkblue;
}
.hover-danger:hover {
  color: red;
}
</style>
